import { render, staticRenderFns } from "./LocationSetup.vue?vue&type=template&id=e23263ee&"
import script from "./LocationSetup.vue?vue&type=script&lang=js&"
export * from "./LocationSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports